module.exports = __webpack_public_path__ + "static/media/logo-voip.fc61b36e.png";